import http from "../http-common";
/* eslint-disable */
class SdmRSService {
  sdmRSList(page, itemPerPage, keyword, id) {
    return http.get(
      "/sdmrs/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&fasyankes_id=" +
        id,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  create(data) {
    var bodyFormData = new FormData();
    if (data.fasyankes_id)
      bodyFormData.append("fasyankes_id", data.fasyankes_id);
    if (data.nama) bodyFormData.append("nama", data.nama);
    if (data.email) bodyFormData.append("email", data.email);
    if (data.phone) bodyFormData.append("phone", data.phone);

    if (data.selectedProfesi && data.selectedProfesi != undefined) {
      bodyFormData.append("profesi_id", data.selectedProfesi.code);
    }

    return http.post("/sdmrs", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    if (data.fasyankes_id)
      bodyFormData.append("fasyankes_id", data.fasyankes_id);
    if (data.nama) bodyFormData.append("nama", data.nama);
    if (data.email) bodyFormData.append("email", data.email);
    if (data.phone) bodyFormData.append("phone", data.phone);

    if (data.selectedProfesi && data.selectedProfesi != undefined) {
      bodyFormData.append("profesi_id", data.selectedProfesi.code);
    }

    return http.put(`/sdmrs/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  delete(id) {
    return http.delete(`/sdmrs/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new SdmRSService();
